module.exports = __webpack_public_path__ + "static/media/slider03.60fcc244.jpg";